import { isBGDark } from './isBGDark';
import { makeRgbBg } from './makeRgbBg';
import { hexRgb } from './hexRgb';

function remHexHash  ( hexhash ) {
    return hexhash.replace('#','')
}

function textColor ( color ){
    return isBGDark(makeRgbBg(hexRgb(`#${color}`, {format: 'array'}))) ? 'white' : 'black';
}

export { remHexHash, textColor };


// WEBPACK FOOTER //
// ./src/utilis/index.js